import React from "react";
import {Link} from "react-router-dom";
import {Navbar, Nav, Container} from "react-bootstrap";
import {FaArrowRight, FaPlayCircle, FaPauseCircle} from "react-icons/fa";
import Intro from "../img/Intro.m4v";
import IntroMusic from "../img/IntroMusic.mp3";

class LandingPage extends React.Component{
    state={
        isPlayed: true,
        videoVolume: 0,
        aboutThisMusic: false,
        loading: true
    };
    playPause = (e) => {
        var video = document.querySelector('#video');
        if(!video.paused){
            video.pause();
            this.setState({isPlayed: false});
        }else{
            video.play();
            this.setState({isPlayed: true});
        }
    }
    changeVolume = (e) => {
        var video = document.querySelector('#video');
        video.muted = false;
        video.volume = e.target.value / 100;
        var guideToUnmuteVideo = document.querySelector(".guideToUnmuteVideo");
        if(guideToUnmuteVideo.style.display !== "none"){
            guideToUnmuteVideo.style.display="none";
        }
        this.setState({videoVolume: e.target.value});
    }
    onPlay = (e) => {
        e.target.loop = true;
        this.setState({loading: false})
    }
    setAboutThisMusic = () => {
        if(this.state.aboutThisMusic !== true){
            this.setState({aboutThisMusic: true});
        }else{
            this.setState({aboutThisMusic: false});
        }
    }
    render(){
        const {onPlay, playPause, changeVolume, setAboutThisMusic} = this;
        const {isPlayed, videoVolume, aboutThisMusic, loading} = this.state;
        return(
            <div>
                <Navbar expand="lg" variant="dark" className="bg-na fixed-top">
                    <Container>
                      <Navbar.Brand className="nav-b">   </Navbar.Brand>
                      <Nav className="ml-auto">
                          <Link to="/signin" className="nav-l">Sign In</Link>
                          <Link to="/register" className="hdf nav-l">Register</Link>
                      </Nav>
                    </Container>
                </Navbar>
                <div className="main">
                    <div className="videos">
                        <div className="videoWithControls">
                        <video autoPlay muted onPlay={onPlay} onClick={playPause} id="video">
                          <source src={Intro} />
                        </video>
                        <div className="guideToUnmuteVideo">
                            <h1>Click Here to Unmute this video</h1>
                        </div>
                        <div className="controls">
                            <span onClick={playPause}>{!isPlayed ? <FaPlayCircle style={{"fontSize": "1.3rem"}} />: <FaPauseCircle style={{"fontSize": "1.3rem"}} />}</span>
                            <h4 onClick={setAboutThisMusic}>Video Credits</h4>
                            <input type="range" value={videoVolume} onChange={changeVolume}/>
                        </div>
                        </div>
                        {aboutThisMusic && 
                        <h5 className="credits">
                            Nicolai Heidlas Music - A Way For Me<br/>
                            ↪ Music Provided by CFM [Copyright Free Music]<br/>
                            ↪︎ <a target="_blank" href="http://bit.ly/2lEd0fW" className="text-light">http://bit.ly/2lEd0fW</a><br/>
                            ↪︎ Facebook <a target="_blank" href="https://www.facebook.com/nicolaiheidlas/" className="text-white">https://www.facebook.com/nicolaiheidlas/</a><br/>
                            ↪︎ Soundcloud <a target="_blank" href="https://soundcloud.com/nicolai-heidlas​" className="text-white">https://soundcloud.com/nicolai-heidlas​</a>
                        </h5>
                        }
                        <h2>Create, Read &</h2>
                        <h1>Organize your books</h1>
                        <div>
                            <h1>at</h1><h2>One Place</h2>
                        </div>
                    </div>
                    <div className="home_page">
                        <h1> Your Personal Book Room </h1>
                        <h2> All your Books at one place </h2>
                        <Link className="createbtn" to="/register"> Create Your Own Book Room <FaArrowRight className="i"
                        /> </Link>
                    </div>
                </div>
                {loading && <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>}
            </div>
        );
    }
};

export default LandingPage;